export default {
  'add-your-clients': 'Add Your Clients',
  'no-clients-description': 'Import and invite your clients to Booksy so you can keep track of client information and they can start booking you online. It\'s a win-win!',
  'import-clients': 'import clients',
  'send-message-to-clients': 'Send message to clients',

  'first-name': 'First name',
  'last-name': 'Last name',
  'pet-type': 'Pet type',
  'weight': 'Weight',
  'breed': 'Breed',
  'registration-number': 'Registration number',
  'make': 'Make',
  'model': 'Model',
  'vin-number': 'VIN number',
  'phone-number': 'Phone number',
  'email': 'Email',
  'address-line-1': 'Street Address & Number',
  'address-line-2': 'Suite Number (optional)',
  'street': 'Street',
  'city': 'City',
  'zip-code': 'Zipcode',
  'birthday': 'Birthday',
  'birthday-placeholder': 'Select date',
  'tax-id': 'Tax ID',
  'internal-note': 'Client note',
  'internal-note-details': 'Client notes (visible for staff only)',
  'allergens': 'Allergies',
  'contact': 'Contact',
  'address': 'Address',
  'add-address': 'Add Address',
  'search-address': 'Search street & number',
  'no-address-found-add-it': 'Can’t find address? Add it here',
  'add-as-street': 'Add "{query}" as a street',
  'add-as-city': 'Add "{query}" as a city',
  'client-discount': 'Client Discount',
  'invite-client': 'Invite Client?',
  'invite-client-info': 'Client will get an invite link to Booksy App',
  'edit-client': 'Edit Client',
  'online-bookings': 'Allow Online Booking?',
  'enabled': 'enabled',
  'general-info': 'General Info',
  'additional-info': 'Additional Info',
  'delete-client': 'Delete Client?',
  'delete-client-description': 'If you delete this client you will lose all information connected to their profile including past appointments, payment history, and more. This action can\'t be undone.',
  'privacy': 'privacy',
  'consents': 'consents',
  'hashtags-tooltip': 'Use a comma, space, or press enter to add a new tag. You can also choose from the list.',
  'tags': 'Tags',
  'tags-placeholder': 'Add tags...',
  'disabling-online-bookings': 'Disable Online Bookings',
  'disabling-online-bookings-description': 'When you disable online bookings for a client they are added to your blocked list. You can still create appointments for them, but they won\'t be able to book themselves.',
  'trusted-client-description': 'You\'ve just added a Trusted Client. This means they will not be responsible for any deposits or cancellation fees when they book with you.',
  'trusted-client-hint': 'The Trusted Client feature allows you to streamline the booking process for loyal clients who have never let you down.<br>Trusted clients will not be responsible for any deposits or cancellation fees when they book with you.',
  'cropper-description': 'Adjust the size of the grid to crop your image. You can also drag your photo to reposition it.',
  'avatar-cropper-description': 'Use your finger or mouse to reposition your image so it fits within the circle.<br/> Also make sure the image looks clear.',
  'upload-new-photo': 'upload new photo',
  'remove-photo': 'remove photo',
  'is-client-avatar': 'Avatar loaded from Booksy Client App',
  'day-and-month': 'Day & Month',
  'year': 'Year',
  'privacy-agreements': 'Privacy Agreements',
  'clients-consents': 'Client\'s consents',
  'client-exists': 'Client already exists',
  'client-exists-info': 'We found an existing client that matches the information you provided',
  'update-existing-client': 'Update existing client with new details',
  'open-existing-client': 'Open existing client profile',

  'add-new-client': 'Add New Client',
  'just-added': 'Just Added',
  'search-placeholder': 'Search client...',
  'search-placeholder-calendar': 'Search by name or phone number...',
  'no-search-results': 'No clients match your search. Try again or add a new client.',
  'no-clients-found': 'No clients found',
  'no-clients-found-description': 'No clients match this criteria. Try selecting another group.',
  'customer-already-exists': 'Client already exists',
  'customer-already-exists-many': 'It looks like this phone number already exists',
  'customer-already-exists-many-email': 'It looks like this email already exists in client base',
  'add-customer-to-appointment': 'Add to Appointment',
  'show-customer-details': 'Show customer details',

  'cancelation-fee': 'Cancellation Fee',
  'prepayment': 'Deposit',
  'appointment': 'Appointment',
  'online-bookings-disabled': 'Online Bookings Disabled',
  'online-bookings-description': 'Edit the client card to enable online bookings.',
  'from-boost': 'from boost',
  'blocked': 'blocked',
  'first-visit': 'first visit',
  'booksy-user': 'booksy user',
  'add-tags': 'Add tags',
  'show-less': 'Show less',
  'more': 'more',
  'invite': 'Invite',
  'add-and-invite': 'Add and invite',
  'call': 'Call',
  'appointments': 'Appointments',
  'total': 'Total',
  'no-shows': 'No-shows',
  'cancellations': 'Cancellations',
  'canceled': 'Cancelled',
  'finished': 'Finished',
  'total-revenue': 'Total revenue',
  'last-visit': 'Last visit',
  'discount': 'Discount',
  'trusted-client': 'Trusted client',
  'details': 'Details',
  'family-friends': 'Family & Friends',

  /* Tabs */
  tabs: {
    'appointments': 'Appointments',
    'physiotherapy': 'Physical therapy',
    'photos': 'Photos',
    'family': 'Family & Friends',
    'about-client': 'About Client',
    'products': 'Products',
    'payments': 'Payments',
    'documents': 'Documents',
    'contact': 'Client info',
    'memberships': 'Memberships',
    'packages': 'Packages',
    'giftcards': 'Gift cards',
  },

  'appointments-tab': {
    'upcoming': 'Upcoming ({value})',
    'past': 'Past ({value})',
  },

  'no-discount': 'No discount',
  'invitation-send': 'Invitation sent',
  'add-documents': 'Add documents',
  'no-documents-added': 'No documents added',
  'delete-document': 'Delete document?',
  'file-uploaded': 'File successfully uploaded',
  'delete-file-confirm': 'Are you sure you want to delete this file?',
  'more-appointments': 'More appointments',
  'custom-forms': 'Custom forms',
  'more-custom-forms': 'More custom forms',
  'more-vouchers': 'Load more',
  'loading': 'Loading...',
  'add-photo': 'Add photo',
  'add-media': 'Add media',
  'more-payments': 'More payments',
  'no-payments-yet': 'No payments yet',
  'more-products': 'More products',
  'no-products-yet': 'No products sold yet',
  'sell-again': 'Sell again',
  'sell-product': 'Sell product',
  'no-upcoming-appointments': 'No upcoming appointments',
  'no-past-appointments': 'No past appointments',

  'all-clients': 'All Clients',
  'search-by-booking-group': 'Search by Booking',
  'new-customers-group': 'Clients registered in the last 30 days',
  'most-loyal-group': 'Clients with at least three visits in the last three months',
  'upcoming-birthdays-group': 'Clients with birthdays this coming week',
  'slipping-away-group': 'Clients who have not booked within the last month',
  'first-visit-group': 'Clients who have booked their first visit',
  'zero-bookings-count-group': 'Clients who haven\'t booked with you yet',
  'active-gift-cards-group': 'Clients with active gift cards',
  'not-booksy-users-group': 'Clients who are not using the Booksy App',
  'search-by-booking-label': 'Search by Booking',
  'new-customers-label': 'New Clients',
  'most-loyal-label': 'Most Loyal',
  'upcoming-birthdays-label': 'Upcoming Birthdays',
  'slipping-away-label': 'Slipping Away',
  'first-visit-label': 'First Visit',
  'zero-bookings-count-label': 'Prospects',
  'active-gift-cards-label': 'Active Gift Cards',
  'not-booksy-users-label': 'Non-App Users',
  'booking-today-label': 'Customers with booking today',
  'tagged-clients': 'Tagged Clients',
  'blacklisted-clients': 'Blocked Clients',
  'search-results': 'Search Results',
  'reset-to-default': 'Reset to default',

  'date-range': 'Date range',
  'services': 'Services',
  'staff-member': 'Staff member',
  'appointment-status': 'Appointment status',
  'any-staffer': 'Any staffer',
  'any-service': 'Any service',
  'any-status': 'Any status',
  'all-time': 'All time',
  'selected': 'selected',
  'today': 'Today',
  'from': 'from',
  'free': 'Free',
  'varies': 'Varies',

  'search-service': 'Search services...',
  'clear-all-services': 'Clear all selection',
  'no-results': 'No results',
  'no-results-description': 'There are no services matching your search',

  'empty-details-tab': 'No info has been added yet. Visit the client profile to make changes.',

  'send-message': 'Send message to client {count} | Send message to clients {count} | Send message to clients {count}',

  'search-client': 'Client search',

  'invite-client-modal-title': 'Client invite will be sent only after selecting both marketing and communication agreements.',
  'invite-client-modal-description': 'Go to "Privacy" tab and switch toggles.',
  'show-privacy': 'Show privacy Agreements',

  'history-of-therapy': 'History of Therapy',
  'patient-file': 'Patient File',
  'physical-therapy': 'Physical Therapy',
  'ministry-of-health-permissions': 'Ministry of Health Permissions',

  'merge': {
    'list': {
      'info': 'Please select the two clients that you would like to merge.',
      'title': 'Merge Clients',
      'merge': 'merge',
      'no-merge': 'No clients to merge',
      'modal-title': 'Merge Failed',
      'modal-text': `The clients you selected are associated with two different Booksy app accounts. We're not able to complete the merge.`,
    },
    'create': {
      'title': 'Select Information & Merge',
      'intro': `For each field on the client card please select the information you'd like to keep. Payment history, past appointments, and future appointments will automatically be combined on the new card.`,
      'client-card': 'Client Card',
      'merged-card': 'Merged Client Card',
      'modal-title': 'Complete Merge',
      'modal-text': `You are about to merge two client cards. This can't be undone. Payment history, past bookings, and future bookings will automatically be merged and added to the new card.`,
      'internal-note-title': 'Internal note',
      'internal-note-details': 'Internal note (visible for staff only)',
      'client-discount': 'Client discount',
      'trusted-info': 'Waive cancellation fee for this client',
      'trusted-title': 'Trusted Client',
      'completed': 'Merge complete!',
    },
  },
  company: {
    'headline': 'Company',
    'add-info': 'Add company details',
    'details': 'Company details',
    'details-customer': 'Customer company details',
    'many-details': 'Companies details',
    'tax-id': 'Tax ID',
    form: {
      'name': 'Company Name',
      'tax-id': 'Tax ID',
      'address': 'Address',
      'city': 'City',
      'post-code': 'Post code',
      'country': 'Country',
      'state': 'State',
      'voivodeship': 'Voivodeship',
    },
  },

  'phone-locked': 'Phone number locked',
  'email-locked': 'Email address locked',
  'stocktake-in-progress': 'Stocktake in progress',
  'warehouse-select-title': 'Which storage location <br> would you like to select?',
  'warehouse-select-description': 'This product is available in several <br> storage locations.',
  'sell-from-selected': 'Sell from selected',
  'warehouse-info-title': 'Unable to sell product',
  'warehouse-info-description': 'Stocktakes are in progress in all storage locations.<br>Please complete at least one stocktake to be able<br>to sell the product.',

  'relationship-types': {
    'pet': 'Pet',
    'partner': 'Partner',
    'friend': 'Friend',
    'spouse': 'Spouse',
    'child': 'Child',
    'other-relatives': 'Other relatives',
  },

  'contact-parent': 'Contact {full_name}',
  'contact-own-details': 'This Client does not have their own contact details. <br/>Would you like to contact the linked account?',
  'customer-assigned': 'The customer record is assigned to {full_name}\'s Family & Friends network. {full_name}\'s contact details are used.',
  'no-family-available': 'No Family or Friend accounts available',
  'no-family-available-desc': 'The client has not added any related accounts <br/>(e.g. Family, Friends, Pets, etc.)',
  'deleted-user': 'Deleted user',
}
